export const JSON_URL = process.env.GATSBY_WORDPRESS_URL;
export const SHOPIFY_ACCESS_TOKEN = process.env.GATSBY_SHOPIFY_ACCESS_TOKEN;
export const GATSBY_SHOPIFY_DOMAIN = process.env.GATSBY_SHOPIFY_DOMAIN;